export default function () {
  return {
    methods: {
      // すべての input type="text" 要素の autocomplete を無効化する
      disableAutocomplete() {
        var textInputs = document.querySelectorAll(
          'input[type="text"], input[type="email"], input[type="tel"]'
        );
        textInputs.forEach((input) => {
          input.setAttribute("autocomplete", this.generateRandomString(16));
        });
      },
      // ランダムな文字列を生成する関数
      generateRandomString(length) {
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        var result = "";
        for (var i = 0; i < length; i++) {
          var randomIndex = Math.floor(Math.random() * charactersLength);
          result += characters[randomIndex];
        }
        return result;
      },
    },
  };
}
